import { EVENT_NAMES } from '../../../../../../utils/f2Constants'
export const MOD_CONTEXT_ENABLE_EVENTS = {
  [EVENT_NAMES.MOD_VIEW_PROSPECTUS]: ''
}
